import useAPI from '@/hooks/useAPI';
import { useQueryResponseMessage } from '@/hooks/useQueryResponseMessage';
import PersonRepository from '@/repositories/PersonRepository';

export const useSyncPersonWithHealthie = ({
  personId,
  enabled = false
}: {
  personId: string;
  enabled?: boolean;
}) => {
  const personRepository = PersonRepository();
  const queryKey = ['syncPersonWithHealthie', personId];

  const queryResponse = useAPI({
    queryKey,
    queryFn: async () => {
      return await personRepository.syncWithHealthie(personId);
    },
    enabled
  });

  const { dataUpdatedAt, isSuccess } = queryResponse;

  useQueryResponseMessage({
    dataUpdatedAt,
    isSuccess,
    queryKey,
    successMessage: 'Successfully triggered Healthie sync'
  });

  return queryResponse;
};
